import images from 'assets/images/images'
import Button from 'components/formElements/Button'
// import Checkbox from 'components/formElements/Checkbox'
import useToast from 'hooks/useToast'
import { useState, useEffect } from 'react'
import { useRequest } from './../hooks/useRequest'
import jwt from 'jwt-decode'
const Login = () => {
	const { showToast } = useToast()
	const [remember] = useState(false)
	const [loginForm, setLoginForm] = useState({ email: '', password: '' })
	const handleChange = (e) => {
		const { name, value } = e.target
		setLoginForm((prev) => ({ ...prev, [name]: value }))
	}

	const [request, loading] = useRequest()


	useEffect(() => {
		if (remember) {
			localStorage.setItem('loginForm', JSON.stringify(remember))
		} else {
			localStorage.removeItem('loginForm')
		}
	}, [loginForm, remember])

	const loginFunc = async () => {
		if (loginForm.email && loginForm.password) {
			await request('/Account/Login', { method: 'POST', data: loginForm }).then((res) => {
				if (res?.data?.result?.token) {
					//firstname , lastname gibi alanlar register işlemlerinden sonra olacak...
					localStorage.setItem('auth', JSON.stringify(res.data.result))
					const userInfo = jwt(res.data.result.token)
					localStorage.setItem('userInfo', JSON.stringify(userInfo))
					showToast('Giriş İşleminiz Başarılı', 'success')
					window.location = '/projects'
				} else {
					showToast('Giriş İşleminiz Başarısız', 'error')
				}
			})
		}
	}

	return (
		<div className='login row '>
			<div className='col-md-6 login-form row'>
				<div className='col-md-8 offset-md-2'>
					<h1 className='mb-4 heading-2 mb-3'>Welcome to Project Portal</h1>
					<div className='mb-4'>
						<div className='form-control'>
							<label className='form-control-label'>Email</label>
							<input onChange={handleChange} className='default-input' type='email' name='email' placeholder='Email' />
						</div>
					</div>
					<div className='mb-4'>
						<div className='form-control'>
							<label className='form-control-label'>Password</label>
							<input onChange={handleChange} className='default-input' type='password' name='password' placeholder='Password' />
						</div>
					</div>
					{/* <div className='mb-3'>
						<Checkbox handleChange={(e) => setRemember(e.target.checked)} label='Beni Hatırla' type='success' id='rememberMe' />
					</div> */}
					<Button
						loading={loading}
						handleClick={loginFunc}
						loadingText = 'Giriş Yapılıyor'
						className='btn-success d-flex align-items-center justify-content-center w-100 p-3'
						title='Giriş Yap'
					//icon={<icons.plus />}
					/>
				</div>
			</div>
			<div className='col-md-6 login-image'>
				<img src={images.loginImage} alt='' />
			</div>
		</div>
	)
}

export default Login
